export enum EConfigurationStatus {
  deployed = 'deployed',
  desired = 'desired'
}
